import { IRegistrationFormValues } from 'affiny-core/modules/api/repositories/registration/registration.types';
import { logger } from '../../logger';
import { ELoggerLevel } from '../../logger.types';
import { tracker, TrackerEvents } from './tracker';

export function trackEventSaga(
  event: TrackerEvents,
  params?: IRegistrationFormValues
) {
  try {
    tracker.strategy.trackEvent(event, params);
  } catch (error) {
    logger.log(error, { level: ELoggerLevel.Warning });
  }
}
